const registry = require('../registry');
// MDC3.0 uses page_Page and page_NavigationSelectedContextPage,
// However, when deploying, this gets transformed into
// navHeading_NavHeading, navHeading_TabNavHeading, and navHeading_NavHeadingRecordList

// BUT... testTree does not do this conversion. So, just pass through to test like we are working with actual metadata
const navHeadings = require('./navHeadings');

const pages = {
    Page: navHeadings.NavHeading,
    NavigationLink: navHeadings.NavHeading,
    //this one shouldn't occur, but just in case:
    NavigationSelectedContextPage: navHeadings.NavHeadingRecordList
};

registry.register('pages', pages);
module.exports = pages;
